<h3 id="fundraising">{{metadata.attributes.HEADING}}</h3>
<p>{{metadata.attributes.DESCRIPTION}}</p>
<form #form="ngForm">
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="companyName">Employer</label>
      <input
        type="text"
        class="form-control"
        id="companyName"
        name="companyName"
        [(ngModel)]="employerInformation.companyName"
        required
        #companyName="ngModel"
      >
      <control-errors [control]="companyName" name="Employer"></control-errors>
    </div>
    <div class="form-group col-md-6">
      <label for="jobTitle">Job Title/Role</label>
      <input
        type="text"
        class="form-control"
        id="jobTitle"
        name="jobTitle"
        [(ngModel)]="employerInformation.jobTitle"
        required
        #jobTitle="ngModel"
      >
      <control-errors [control]="jobTitle" name="Job Title/Role"></control-errors>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6" id="employer-information-workPhoneNumber">
      <label for="workPhoneNumber">Work Phone Number (Optional)</label>
      <input
        type="text"
        mask="000-000-0000"
        placeholder="111-111-1111"
        class="form-control"
        id="workPhoneNumber"
        name="workPhoneNumber"
        [pattern]="phoneValidator"
        [(ngModel)]="employerInformation.workPhoneNumber"
        #workPhoneNumber="ngModel">
      <control-errors [control]="workPhoneNumber" name="Work Phone Number"></control-errors>
      <p class="input-annotation">You will receive texts and calls at this number about this event and upcoming LLS events, fundraisers, and offerings. You will have the ability to opt out once communication begins.</p>
    </div>
    <div class="form-group col-md-6" id="employer-information-workEmail">
      <label for="workEmail">Work Email Address (Optional)</label>
      <input
        type="email"
        class="form-control"
        id="workEmail"
        name="workEmail"
        [(ngModel)]="employerInformation.workEmail"
        email
        #workEmail="ngModel">
      <control-errors [control]="workEmail" name="Work Email Address"></control-errors>
    </div>
  </div>
</form>
